import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

const useUrlQueryParam = (paramName: string, defaultValue: string) => {
  const router = useRouter();
  const [paramValue, setParamValue] = useState<string | string[] | undefined>(
    router.query[paramName] || defaultValue
  );

  useEffect(() => {
    if (!router.query[paramName]) {
      router.replace(`${router.pathname}?${paramName}=${defaultValue}`);
    }
  }, [router, paramName, defaultValue]);

  const updateParamValue = (newValue: string) => {
    setParamValue(newValue);
    router.push(`${router.pathname}?${paramName}=${newValue}`);
  };

  return [paramValue, updateParamValue] as const;
};

export default useUrlQueryParam;
